import React, { useState, useEffect } from "react"
import { Input, Form, Space, message, Tooltip, Modal } from "antd"
import TableCustom from "src/components/Table/CustomTable"
import SvgIcon from "src/components/SvgIcon"
import Button from "src/components/MyButton/Button"
import CB1 from "src/components/Modal/CB1"
import FilterRequest from "./components/FilterRequest"
import PopupAction from "src/components/PopupAction"
import IconBase from "src/components/IconBase"
import { groupBy, set } from "lodash"
import STORAGE, { getStorage } from "src/lib/storage"
import { WrapperStyle } from "../../HumanResource/styled"
import { ToolBarStyle } from "../../HumanResource/Work/Task/styled"
import SettingPriceService from "src/services/SettingPriceService"
import SimVariantModal from "./components/SimVariantModal"
import ListPrice from "./components/ListPrice"
import ModalAddPrice from "./components/ModalAddPrice"

const SettingSimPrice = () => {
  const [modalType, setModalType] = useState(null)
  const [form] = Form.useForm()
  const [editingRecord, setEditingRecord] = useState(null)
  const [summary, setSummary] = useState()
  const [refresh, setRefresh] = useState(false)
  const [isModalAddVisible, setIsModalAddVisible] = useState(false)

  const [shownError, setShownError] = useState(false)
  const permissions = localStorage.getItem(STORAGE.PERMISSIONS) || ""

  const hasPermission = permissions.includes("setting.list")

  useEffect(() => {
    if (!hasPermission && !shownError) {
      message.error("Không có quyền truy cập")
      setShownError(true)
    }
  }, [!hasPermission, shownError])

  if (!hasPermission) {
    return null // hoặc <Navigate to="/not-authorized" />
  }

  return (
    <div>
      <WrapperStyle>
        <ToolBarStyle>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginTop: 4,
              marginBottom: 20,
              flexWrap: "wrap",
              gap: 8,
            }}
          >
            <h3
              style={{
                fontSize: "24px",
                fontWeight: "bold",
                color: "#005F90",
                margin: 0,
              }}
            >
              GIÁ BÁN SIM
            </h3>
          </div>
          <div className="right-side">
            {permissions.includes("setting.create") ? (
              <Button
                btnType="primary1"
                onClick={() => setIsModalAddVisible(true)}
              >
                Tạo mới
              </Button>
            ) : (
              <React.Fragment />
            )}
          </div>
          <div style={{ width: "100%", overflowX: "auto" }}>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                // margin: "10px 0",
              }}
            >
              <div
                style={{ color: "#007BFF" }}
              >
                <strong>Tổng số: {summary}</strong>
              </div>
            </div>
            {permissions.includes("setting.list") ? (
              <ListPrice refresh={refresh} setRefresh={setRefresh} setSummary={setSummary} />
            ) : (
              <React.Fragment />
            )}
          </div>
        </ToolBarStyle>
      </WrapperStyle>
      {modalType === "view" && (
        <SimVariantModal
          visible={modalType === "view"}
          onClose={() => setModalType(null)}
          record={editingRecord}
        />
      )}
      {isModalAddVisible && (
        <ModalAddPrice
          open={isModalAddVisible}
          onCancel={() => setIsModalAddVisible(false)}
          onSuccess={() => setRefresh(prev => !prev)}
        />
      )}
    </div>
  )
}

export default SettingSimPrice
